var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamingTimeCheckFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c.966 0 1.75.784 1.75 1.75v.307c1.2.34 2.198.995 2.993 1.962a5.684 5.684 0 011.328 3.716v7.777h1.13c.226 0 .415.075.569.224.153.15.23.335.23.557a.746.746 0 01-.23.557.783.783 0 01-.57.224h-4.454a2.748 2.748 0 01-5.492 0H4.8a.783.783 0 01-.57-.224.749.749 0 01-.23-.558c0-.221.077-.407.23-.557a.783.783 0 01.57-.223h1.129V9.735c0-1.401.442-2.64 1.328-3.716a5.865 5.865 0 012.993-1.962V3.75c0-.966.784-1.75 1.75-1.75z",
    fill: "currentColor"
  })));
}
SvgGamingTimeCheckFilled.displayName = 'GamingTimeCheckFilled';
export default SvgGamingTimeCheckFilled;